import { Checkbox, TableCell } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export default function CheckboxCell({
  id,
  data,
  isItemSelected,
  selected,
  setSelected,
  wrapInTableCell = true,
}) {
  const handleChange = () => {
    setSelected(
      isItemSelected
        ? selected.filter((obj) => obj.id !== id)
        : [...selected, data.find((x) => x.id === id)],
    );
  };

  const checkboxContent = (
    <Checkbox
      checked={isItemSelected}
      onClick={(event) => event.stopPropagation()}
      onChange={handleChange}
      icon={<div className="custom-checkbox" />}
      checkedIcon={
        <div className="custom-checkbox">
          <CheckIcon />
        </div>
      }
    />
  );

  if (!wrapInTableCell) {
    return checkboxContent;
  }

  return (
    <TableCell data-skip-row-click padding="checkbox">
      {checkboxContent}
    </TableCell>
  );
}
